import {FCWithChildren} from "@/app/types/reactTypes";

const LabelWithUnderline: FCWithChildren = ({children}) => (
	<div className="w-fit">
		<span className="pb-1 text-gray-800 group-hover:text-gray-900">
			{children}
		</span>
		<div className="h-1px origin-left scale-x-0 bg-navy-700 transition-transform duration-300 ease-out group-hover:scale-x-100 group-focus:scale-x-100" />
	</div>
);

export default LabelWithUnderline;
